export const IN_PROCESS = "IN_PROCESS";
export const FINISHED_WIN = "FINISHED_WIN";
export const FINISHED_LOSE = "FINISHED_LOSE";
